import React, { useState } from 'react';
import axiosInstance from "../utils/axiosInstance";
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

function DeliveryNotePrintButton({ orderData, isEditMode, loading, error }) {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async ({ force = false } = {}) => {
        if (isEditMode || !orderData || downloading) return;

        setDownloading(true); // ダウンロード開始
        try {
            // force=trueならサーバー側でキャッシュ無視
            const urlPath = `/pdf/deliverynote/${orderData.order_id}${force ? '?force=true' : ''}`;
            const response = await axiosInstance.get(urlPath, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            window.open(url, '_blank');
        } catch (err) {
            alert('PDFの取得に失敗しました');
            console.error(err);
        } finally {
            setDownloading(false); // 終了
        }
    };

    if (loading) return <p>読み込み中...</p>;
    if (error) return <p>エラーが発生しました</p>;

    return (
        <>
            <Button
                type="button"
                disabled={isEditMode || !orderData || downloading}
                onClick={() => handleDownload()}
                variant="contained"
                endIcon={<DownloadIcon />}
            >
                {downloading ? 'ダウンロード中…' : '納品書のダウンロード'}
            </Button>
        </>
    );
}

export default DeliveryNotePrintButton;
